import React from 'react';
import { Flex, View } from '@aws-amplify/ui-react';

const LeftAlignedRow = ({children, ...props}) => {

    return (
        <View style={{marginLeft: '0.5rem'}}>
            <Flex direction="row" >
                {children}
            </Flex>
        </View>
    )
}

export default LeftAlignedRow;